(function () {
  // Tēmas dublēto H1 un breadcrumb izņemam no DOM (SEO: lapā tikai viens H1)
  document.querySelectorAll('.main-page-title, nav.breadcrumb').forEach(function (el) { el.remove(); });

  var reveals = document.querySelectorAll('.espm .reveal');
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px' });
  reveals.forEach(function (el) { io.observe(el); });

  // Drošības tīkls: ja novērotājs kaut kāda iemesla dēļ nenostrādā,
  // saturs tik un tā parādās – neviens nedrīkst palikt tukšā lapā.
  setTimeout(function () {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }, 2500);
})();
